import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

export const FloatingPanel = styled.div`
  position: relative;
  pointer-events: auto;
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  justify-content: space-evenly;
  gap: 16px;

  height: 40px;

  background: ${themeStyle.varBackgroundAlt};
  box-shadow: ${themeStyle.varShadowMedium};
  padding: 8px 16px;
  border-radius: ${themeStyle.radiusMedium};
`;
